<div class="alert alert-{{ boxType }}"
     [ngClass]="additionalClasses"
     [attr.role]="getRole()"
     id="hb-{{ boxId }}">

    @if (boxTitle) {
        @switch (headerSize) {
            @case ('h2') { <h2 class="ba-heading">{{ boxTitle }}</h2> }
            @case ('h4') { <h4 class="ba-heading">{{ boxTitle }}</h4> }
            @case ('h5') { <h5 class="ba-heading">{{ boxTitle }}</h5> }
            @default {     <h3 class="ba-heading">{{ boxTitle }}</h3> }
        }
    }

    @if (boxMessage) {
        <p [innerHTML]="boxMessage"></p>
    } @else {
        <ng-content></ng-content>
    }
</div>
